import { render, staticRenderFns } from "./TolErrors.vue?vue&type=template&id=bcbd43d6&scoped=true&"
import script from "./TolErrors.vue?vue&type=script&lang=js&"
export * from "./TolErrors.vue?vue&type=script&lang=js&"
import style0 from "./TolErrors.vue?vue&type=style&index=0&id=bcbd43d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbd43d6",
  null
  
)

export default component.exports